module.exports = __webpack_public_path__ + "static/media/visitas_orientadas_top_banner.5e3638e6.webp";